import type { Cmcd } from './Cmcd.js';

/**
 * A CMCD key.
 *
 * @group CMCD
 *
 * @beta
 */
export type CmcdKey = keyof Cmcd;
